import React, { FC } from 'react';
import Container, { Logo, Spinner } from './styles';

const Loader: FC = ({ ...props }) => {
  return (
    <Container {...props}>
      <Logo />
      <Spinner />
    </Container>
  );
};

export default Loader;
